import PalletBuilderSuperStore from "../../stores/PalletBuilderSuperStore";

export const ReprintPalletMachineConfig =
    {
        services: {
            getPalletsForReprint: ctx => new PalletBuilderSuperStore().getPalletsForStation(),
            printManifest: ctx => new PalletBuilderSuperStore().printManifest(ctx.pallet.id, ctx.printOptions.stationId, ctx.printOptions.saveDesignerData),
            generateDataSource: ctx => {return new PalletBuilderSuperStore().getPalletForReport(ctx.pallet.id)},
        },
        actions: {
            logError: (context, event) => {
                console.error(event);
                context.error = event;
            },
        }
    }

export default ReprintPalletMachineConfig;